/*  VOCAL TAPES 1.0 PREVIEW DATA.

    Three tables the player reads before it fetches a byte of audio: the waveform to
    draw, how long each preview runs, and the level to play it at. Keys are the filename;
    ev-kit-audio.js runs every key through stem(), which strips path and extension.

    IT MERGES, IT DOES NOT REPLACE. Object.assign onto whatever is already there.

    IT MUST LOAD AFTER ev-peaks.js, ev-dur.js and ev-gain.js, and BEFORE ev-kit-audio.js,
    which snapshots EV_PEAKS into its own decoded cache at startup and never looks again.

    150 BARS, MATCHING N IN ev-kit-audio.js.

    THE VOCAL KITS AIM AT -17 dB, NOT THE -12.6 dB EVERY OTHER PAGE USES, and that is a
    decision Carlos made rather than a measurement. Vocals are quiet and dynamic: across
    Vocal Tapes 1 and 3 together the median file can only reach -14.4 dB before its own
    peak hits the 0.99 ceiling, and the quietest loop tops out near -19. Forcing them at
    the melodic target would have meant either previewing only the loudest handful, which
    misrepresents a vocal kit, or running a limiter over the audio, which changes the
    files and is the kind of change he has to hear first.

    So the whole vocal family sits about four decibels under the melodic pages. That is
    audible when you move between them and it is meant to be: a vocal sitting slightly
    under a melody reads as natural rather than broken. Use this same -17 dB for Vocal
    Tapes 2 and 3 and for the bundle, or the family stops matching itself.

    All 24 below land within 1.2 dB of it. VT1D is the dry folder, VT1W the wet one, and
    they are different vocals rather than two versions of the same take.

    EVERY NUMBER BELOW IS MEASURED. The first version of this file was deployed with the
    gains typed from memory rather than read out of the measurement, and every one of them
    was wrong, several by a factor of two. Regenerate this file from vt1_data.json, never
    by hand.

    REGENERATE WHEN THE PREVIEWS CHANGE.  */

window.EV_PEAKS = Object.assign(window.EV_PEAKS || {}, {
  "VT1D_-_WHISTLE_FSHARP_94": "AQECCQghCQYFg5uTpZWGqZqcqaaxm5OcmJaozJWim6iOk5p0hX4MDQ0LCwcEAxmfpfDGwNzEzOHNs8K/vLvHt7u2zf+2rqaWHgICAgACCAcgCwUGmY+SoZqMroqGuaGsk5KaoJ6b15WiocaImZN6h30MCxALCQcEAxWkoubCp9+4z9/MzM3Ews7Ix8S6q+iruq+dEwMC",
  "VT1D_-_SIDEPC_FSHARP_150": "uvrGxcT5gOXanoiPk5eOjITMm5ObWhACAAAAAAAAAAAAAAAAABipuevG171OCnGToWZGB6eowbu1qbDRjWMIBQAAAAAAAAAAAAAARBL//8Wn29vu3uSlwJaQiLqAMxYQCwECAAAAAAAAAAAAAAAAACjryLRNpNnRu72CObrFp0tZQSIhBgEAAAAAAAAAAAAAAAAAAAAA",
  "VT1D_-_XY_F_124": "u3Gar9HHrb+tsKSUr6ibsrGii5ZroKyYmaWgkqWFn7azpJW209m/wL3P3afOx928z8OmqYV2cD2dsq7NxrmjwqWoprK0qbq0rLO50N3P1ezF//rG0uvn1czfl5CCiT49laG8f3+8rc3J0crAvLy2mYODpbrS78rd/djC6r2ahnuCdnE5M+zf2b+OnL/Fk6R1f5Gns5GC",
  "VT1D_-_ECHO_ASHARP_98": "+qiNrZafm4J+lHMW8fqSi1oM1M2NmHlhPQQCAgIABQUbrax5fIRweXVxb2NeYSwEEhK7goJ5cz64dG1oboNmCAIBAAMZDRL8pJeDiYR/eX9rZEwKAAAAqPObim0MCOuflIlmTwsCAgIAAAAC4MKZn52OrZmln393PQYKAAD/xIl/XAm1dHN3enRlGAIKAQECAgMHBgMC",
  "VT1D_-_RODEO_G_98": "AAAAAAAAAAAAAURleqqrqWhjWWVydW5yfnN4dF9VbG5fUXFpXWRhRYuKiZWSdGpoa4G91NjP//To6sWCfY6Cc2xCUE9NLggFAwMCAQAAAAAAAAAGAkRrdoN+eo9OOz5VUExdWD87NTY5QEM/TlRLRJ3Kg8XTxa2gm5WKhoN0WmVEKRcFAl9njbXSuJ6qchELBwQEBAQD",
  "VT1D_-_BUTTERFLY_ASHARP_96": "Sa3csM3l1d2fZm7Ww6Ogw66kZ2GwypHav6zGfUqVv8CxZ157Yz94mrqb4eDVuY8woayXlIyLrJJvj7aitNba1JuAPm2XrqSJYD0dPMPczLHg396YZW+7vbubn6BlSV621rbvw7TVkFWFnKKXZl13ZDpwq7uW3uvXwokyk5qfjn2AmpZkmKbDzu7/y4eMQoKkuqqFTCIO",
  "VT1D_-_BRENT_B_160": "ICy2+vq0jXdXYYetrKKXnXKGeypMdJx7hJTAgpaccVlLUiwRBRIsfdz466N5UV17rLa3nLZlnIN1KnZ6kXye1LuFfY5XS1UsLQgDIC6w5vOrmnNcYoS1uKGQoIeUeixOeouIkpzIdIuKelVGTigUBg8ncNb/3bWDX2CDrru4iIlahXpuJmmBnYqixcGBin9TT1QoKggD",
  "VT1D_-_WANT_YOU_ASHARP_160": "g+rP44r/f4OIjqyxqrKiclk7YWnp4NPLphgFAwIAAAAAAAAAALS4v5uUo5GFgGVqtsOZWnKJeHuakomVbXF0Zn9tepCPeSIDAgAAaOWlrYDagZaNfaWsvLqlgGVLan/B7ePPthsFBAIAAAAAAAAAANyjsJCAq6F8f2uM1KaYX3eDm3CCoZqjdmZoWG1me4aSYCkDAwAA",
  "VT1D_-_FALLING_DSHARP_95": "rbZiMzVhf5FkYVGNhpOKglk+EwUHAAAAAAAAAAAAAAASh31gQLqL6v/NPazKv3w1aWaZnYd5gmJkbBYJDDKFlpuRoI6WqKqLgoU/xLBgNzFgaopmYliBh46Nf1ZBDgUIAAAAAAAAAAAAAAAsmGhjN3mJ5M+tcYyfp3czcmuei4N6f2tjaBwICjKVlZ+ZnJSfpLqZlGxA",
  "VT1D_-_RYTHM_FSHARP_96": "AAkxYrnH2K9ZR1F3mfPwxsaFZDs3ITKFnZ6UlIt8WhQIAgEAAAECKDydwMy6dlA/S3Ci+8jBoH5GNiUbX66rnqykmX03DQUBAQAAAgQuVKnDyaZYSVt9pvz/trh2ZTc/IjuptbW+t7KbcBYIAgEAAAIDHUaXorGNglJHUJmksIylgXJgVyslSHFrT0JJRkAxLS4tIhwR",
  "VT1D_-_MELLOTRON_C_92": "RndjTXvo/5KRjl+XkIFZW452QXdycnF3fm1sa184EgUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJ1piTVKG9besoW2rqIZPYmB0Vo2HmJykoFtdXFc5EgQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA",
  "VT1D_-_FINAL_BOSS_A_90": "HH7M6MLw/9fQvaPEycWhr6qXf0pRRzBOaVVZTjhHWUpibllRUkNmlbCnopypw7adrKe0o6vFoIBzW0pkWUNkcmZBOipTUEpWWEQxSGOfy8zJ2sjZ6d/BppdqbXt1aWp2VG+plZGPn3pncHVdZ2htS0pyj8bBpMy3v7ugpqCoq3y4jGBVST40LzE5RkMnJTQ7PT8lIBYJ",
  "VT1W_-_LAYER_CSHARP_94": "AAACCwkfDgcHusek0NnU5c670cTcwr+yqLXA/rK81Ny2uMKelZgmRiouJBcaHhqRoNrNssnL0OHLuLbG1Kqzp73Iw+rIorKTNDYxJC4hIBIhGhoSpayoyM+8+7iz2MrdtbihobvB/6jCyt3AvbyvoaEiRDI1KxkTHh2Jq9Gmmt7K+u3dqay0saGrnLaxydSmoqCaMzs6",
  "VT1W_-_DELAY_FSHARP_130": "y8+ytv/Oo72jqa/Arp2Xyb+ohIWPgsPFyLzLtc+psaqYjamsqa6eo5qgrbS3o5mcqNiTsIfKt6TVw76WssCwmqGslMGrUTgLXpDEpBcBAiWGv6EGAAIFccOkAQACAYzRWgEAAgF6vR8AAgEBe60XAQIBBaCVBgACAQJ6gAIAAwIGhUsBAQMCEnUXAQMCAhttCAEDAQAA",
  "VT1W_-_RNB_CSHARP_80": "b5uropvd7YgmcVijqKeVq55vMEGC1cbAu6+AI6GWoJ62urKabK3N6enBDgECAwEIDhdVfLSUiUpVWzxdo3yViDhAdZixwXJ+n2tS1dfn5q15xs5tSWnLlG6tw9zFWGRRS01VbGpjOYp4ZYaZmYmWWvzz/+7kIwECAgIGFSk+j4erWEiqvrCYVQECAgIFCxo0OZOFpW44",
  "VT1W_-_BACKR00MS_DSHARP_88": "DklbanVTfZivnrCvu5A6OU6Ins7LsMevmI7Fm6jR8LWQhYx7kqu6sGpiZ32ntpuWr63GnFFarcXV5uK0wrLCts68rePe0JWMjKu1zvDhnIl1hqmzmb2mtqk/NVeOocK3r8LAnqG0pa3/+bSpkp67faejioSBaYKav5Glur7GlllWqr/Jurjivamlz8G39/7qt5iMd2ZL",
  "VT1W_-_OMINOUS_G_110": "AQkZMElwkImgq5ebjKbDsc/33N7XzNel0Me9sKGvxqeRclw4KBcgLVRaboecmIafpbm+/8nly7uvv6eks4WHlnFsaGhwb2pgIQ8NCAgcN0xlfIyPiJKckI2/xbjC46/QyMK4267YsKW4uqeifUlEJxwjLEtfcG2AlZS4psXP2bu9wsTHyKCvr4R7h4t0Y2twa2pgJBEN",
  "VT1W_-_SOMETHING_E_96": "P4GLlH1Alp9ucoWZjZJZyf/PrcD3iZiMl6p5aqDPzL/SbMy9rI2Pm5aNd3WTfF1ofJWIeaDG8KGm4sChh0OXrmOEzsumzLCsyqiRZIOOjoAwk5lfeYKSiY9ly/3MtNT1nYZ9oKlzYaTc2MWiSLurwoeUjqWZgnyTiWVweouUiqjJ28HH5cmvlUevrnOMusGquqiqpq+f",
  "VT1W_-_SAY_SUM_ASHARP_110": "AwMDBQYHDw8LDAhawH/m2LqYr4VznLCkhDoFBAUFDAoLCRWumfHg/+HflCskEwoLCQUDAgECCwcHBwcFBxNNntjhunVRUT52VzMrCQwmPTxiZjxWWlZLSkg5OFNsX4GPmouSn2ExKjozOhQPBgQCAgIBAgEBAQEBAQEBAQEBAQEBAQEBAQECAQEBAQECAQEBAQEBAgEB",
  "VT1W_-_NO_KEY_101": "rraSbUtYYoF+RE5CV1t1iot/3M3SrtvYVTQbF5elp6pOY4SFfDozRE89XlFXY1xgrLCicyYeDwid1Zp4W36MgIh8YF5mTFFUVzgdiMujeUdUUYyFUUBRU0eJmYCbobXD6v/GllsuRq+8ZmduTlB8cXA/SE1PeWNpeZByn7aPZzoWETl4wb5ycnVmbXdZgHpySV9iiVMS",
  "VT1W_-_MUSIQ_D_108": "wPS3wrWUTUTieYyIcVLMeZeSd1VSSmRoUFBPODeJw5WDj7eocVS/jba1i3A80XyTqJprmMmfo31nSks/WFM+VlBLUkRAWj5NPz0p5v/Jyb6Sa07Th5CgiF3XnKmbbVhPTlViZlVQTUKqnomOkKOZcFfMpqyslo88r22ImYddxM2Uh25oTVJWV1tNVTVFLzIzTkIoMTAd",
  "VT1W_-_NICO_ASHARP_95": "uOfAo5fM/8XDj6+dlXyEgIVdJ1GEm4m3wrCYfzgvFRtXVGOssaqlWBIXKDErJzI2LgsWNUtIKCcfIAcHBSAdGS49MysdGxYTBAMDub2vs4Hb8dfjkKihl32Wb3tqNVeVoJHO1LKPfTk1FBpIVmG6sa+fTBAXJispJTE8KAsVMEVGKSoeHQcHBh8iHjU6NisfGxcTBQMF",
  "VT1W_-_FELT_PIANO_F_95": "E1eAkYukp6jfxjt//+Xsn1mNgi17fLe63b19k4GcfYZQhZ99b00ydH1rnKR1brlFY5CTlNJbgXZ2Z5GGtLrWzL24WJByjHWUgHZtMZ2Op5Gg2a3c5VSl4uDKqG2VgC11mLy9vbB9sHmIfJxMbIduWkEtZn1qi5lxiuhAYpqZlpRZdnZ3XXyBxLnWxKLQT4Z1g1mDd2Fo",
  "VT1W_-_BO3_105": "AE52ZFtZwvv/3XZmeHVVEwICW3WMlZK1vYJoXHZxWVNHZnthU11QUldfe4mUaCtMWlxFFhwdEU/W34VwbIqBdjghHzClnZqJf19eeodXPj48JxwdHRsXExAQDBAYIyYdISAfGBYeIxwbFA0KEhMTEAsFAwYGDQ0LCw0ODQ4NDA4NCwQEBgMHBgUEAgIDBAYGBQcHBQUF"
});

window.EV_DUR = Object.assign(window.EV_DUR || {}, {
  "VT1D_-_WHISTLE_FSHARP_94": 10.21,
  "VT1D_-_SIDEPC_FSHARP_150": 12.8,
  "VT1D_-_XY_F_124": 15.48,
  "VT1D_-_ECHO_ASHARP_98": 9.8,
  "VT1D_-_RODEO_G_98": 4.9,
  "VT1D_-_BUTTERFLY_ASHARP_96": 20.0,
  "VT1D_-_BRENT_B_160": 12.0,
  "VT1D_-_WANT_YOU_ASHARP_160": 12.0,
  "VT1D_-_FALLING_DSHARP_95": 10.11,
  "VT1D_-_RYTHM_FSHARP_96": 10.0,
  "VT1D_-_MELLOTRON_C_92": 10.43,
  "VT1D_-_FINAL_BOSS_A_90": 10.67,
  "VT1W_-_LAYER_CSHARP_94": 10.22,
  "VT1W_-_DELAY_FSHARP_130": 5.08,
  "VT1W_-_RNB_CSHARP_80": 12.0,
  "VT1W_-_BACKR00MS_DSHARP_88": 21.82,
  "VT1W_-_OMINOUS_G_110": 17.45,
  "VT1W_-_SOMETHING_E_96": 20.0,
  "VT1W_-_SAY_SUM_ASHARP_110": 6.55,
  "VT1W_-_NO_KEY_101": 4.2,
  "VT1W_-_MUSIQ_D_108": 8.89,
  "VT1W_-_NICO_ASHARP_95": 10.11,
  "VT1W_-_FELT_PIANO_F_95": 20.21,
  "VT1W_-_BO3_105": 4.58
});

window.EV_GAIN = Object.assign(window.EV_GAIN || {}, {
  "VT1D_-_WHISTLE_FSHARP_94": 0.984,
  "VT1D_-_SIDEPC_FSHARP_150": 0.794,
  "VT1D_-_XY_F_124": 1.753,
  "VT1D_-_ECHO_ASHARP_98": 0.989,
  "VT1D_-_RODEO_G_98": 1.161,
  "VT1D_-_BUTTERFLY_ASHARP_96": 1.138,
  "VT1D_-_BRENT_B_160": 1.418,
  "VT1D_-_WANT_YOU_ASHARP_160": 1.243,
  "VT1D_-_FALLING_DSHARP_95": 1.389,
  "VT1D_-_RYTHM_FSHARP_96": 1.462,
  "VT1D_-_MELLOTRON_C_92": 1.431,
  "VT1D_-_FINAL_BOSS_A_90": 1.742,
  "VT1W_-_LAYER_CSHARP_94": 1.063,
  "VT1W_-_DELAY_FSHARP_130": 1.403,
  "VT1W_-_RNB_CSHARP_80": 1.522,
  "VT1W_-_BACKR00MS_DSHARP_88": 1.507,
  "VT1W_-_OMINOUS_G_110": 1.732,
  "VT1W_-_SOMETHING_E_96": 2.174,
  "VT1W_-_SAY_SUM_ASHARP_110": 1.138,
  "VT1W_-_NO_KEY_101": 1.073,
  "VT1W_-_MUSIQ_D_108": 2.739,
  "VT1W_-_NICO_ASHARP_95": 1.787,
  "VT1W_-_FELT_PIANO_F_95": 2.464,
  "VT1W_-_BO3_105": 1.615
});
